<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Files</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <article class="media" v-if="attachments.length > 0">
              <div class="columns is-multiline">
                <template v-for="file in attachments">
                  <div class="column is-6" style="text-align: center;">
                    <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                      <a :href="file['url']" target="_blank" style="border-bottom: none;">
                        <img :src="file['url']" alt="" width="90%">
                      </a>
                    </template>
                    <template v-else>
                        <a :href="file['url']" target="_blank" style="border-bottom: none;">
                          <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                          {{file['file'].split('/')[3]}}
                        </a>
                    </template>
                  </div>
                </template>
              </div>
          </article>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      parent: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      hotel_id: {
        type: Number
      },
      chain_id: {
        type: Number
      },
      provider_id: {
        type: Number
      },
      agency_id: {
        type: Number
      }
    },
    data () {
      return {
        attachments: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      close (closeOnly) {
        if (!closeOnly) {
          this.parent[this.callback]()
        }
        this.$el.remove()
      },
      loadData () {
        let url = this.context.$store.state.config.apiURL + '/comments/files/'
        if (this.hotel_id) {
          url = url + 'hotels/' + this.hotel_id
        } else if (this.chain_id) {
          url = url + 'chain/' + this.chain_id
        } else if (this.provider_id) {
          url = url + 'provider/' + this.provider_id
        } else if (this.agency_id) {
          url = url + 'agency/' + this.agency_id
        }
        this.context.$http.get(url).then((response) => {
          this.attachments = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
    }
  }
</script>
<style lang="scss" scoped>
  #dropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// CommentAttachments.vue?2cd352ee